import React, { useEffect, useRef, useState } from 'react';

/**
 * Section illustration: scroll reveal + subtle uniform scale (no crop/stretch).
 * Wrapper only clips overflow; no card border so photos sit flush on the section.
 */
export default function AnimatedSectionImage({ src, alt, className = '', delay = 0 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.15 },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`overflow-hidden rounded-2xl transition-all duration-700 ease-out ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      } ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className="block w-full h-auto max-h-[420px] lg:max-h-[min(75vh,640px)] origin-center animate-ken-burn-subtle"
      />
    </div>
  );
}
